import type {
  InvoiceCandidateBillableDateSource,
  InvoiceCandidateExclusionReason,
  InvoiceCandidateOrderType
} from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

/**
 * `label` reads as a filter (plural), `rowLabel` as one row's badge.
 *
 * Icons match the Orders tab on the invoice detail page, so the two types look
 * the same wherever an order is shown.
 */
export const ORDER_TYPE_OPTIONS: {
  value: InvoiceCandidateOrderType;
  label: string;
  rowLabel: string;
  icon: NoddiIconName;
}[] = [
  { value: 'booking', label: 'Bookings', rowLabel: 'Booking', icon: 'CalendarDays' },
  { value: 'tire_quote', label: 'Shop purchases', rowLabel: 'Shop purchase', icon: 'ShoppingCart' }
];

/** The value the status filter uses for "nothing is wrong with this order". */
export const WILL_BE_BILLED = 'will_be_billed';

/**
 * The record carries the raw enum, not a `{value, label}` pair, so the label
 * belongs here. Mirrors `InvoiceCandidateExclusionReason` on the backend.
 */
export const EXCLUSION_REASON_LABELS: Record<InvoiceCandidateExclusionReason, string> = {
  not_billable_status: 'Not billable status',
  has_payment: 'Has payment',
  already_invoiced: 'Already invoiced',
  no_billable_lines: 'No billable lines',
  external_settlement: 'Not paid in this system'
};

/**
 * What dated the row. A date with no event behind it is what made this column
 * unreadable: the same column can hold the day work finished and the day an
 * order was raised, and only the first belongs to the period being billed.
 */
export const BILLABLE_DATE_SOURCE_LABELS: Record<InvoiceCandidateBillableDateSource, string> = {
  booking_completed: 'Booking completed',
  quote_fulfilled: 'Purchase fulfilled',
  order_created: 'Order created'
};
